<template>
  <div class="col-xxl-8 col-md-12 box-col-8 col-ed-8 col-12 ms-xxl-5 mb-3">
        <div class="card h-100">
          <div class="card-header card-no-border">
            <div class="row">
              <div class="col-12"> 
                <div class="key-metrics">Key Metrics</div>
              </div>
              <div class="col-12">
                <div class="row">
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Today',
                      'btn-primary': activeButton === 'Today'
                    }"
                    :style="getButtonStyle('Today')"
                    @click="setActiveButtonWrapper('Today')"
                  >
                    Today
                  </button>
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Yesterday',
                      'btn-primary': activeButton === 'Yesterday'
                    }"
                    :style="getButtonStyle('Yesterday')"
                    @click="setActiveButtonWrapper('Yesterday')"
                  >
                   Yesterday
                  </button>
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'This week',
                      'btn-primary': activeButton === 'This week'
                    }"
                    :style="getButtonStyle('This week')"
                    @click="setActiveButtonWrapper('This week')"
                  >
                    This week
                  </button>
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Last week',
                      'btn-primary': activeButton === 'Last week'
                    }"
                    :style="getButtonStyle('Last week')"
                    @click="setActiveButtonWrapper('Last week')"
                  >
                    Last week
                  </button>
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'This month',
                      'btn-primary': activeButton === 'This month'
                    }"
                    :style="getButtonStyle('This month')"
                    @click="setActiveButtonWrapper('This month')"
                  >
                    This month
                  </button>
                  <button v-if="!isScreenSmall"
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Last month',
                      'btn-primary': activeButton === 'Last month'
                    }"
                    :style="getButtonStyle('Last month')"
                    @click="setActiveButtonWrapper('Last month')"
                  >
                    Last month
                  </button>
                </div>
                <div class="row mt-2">
                  <button v-if="isScreenSmall"
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Last month',
                      'btn-primary': activeButton === 'Last month'
                    }"
                    :style="getButtonStyle('Last month')"
                    @click="setActiveButtonWrapper('Last month')"
                  >
                    Last month
                  </button>
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'This year',
                      'btn-primary': activeButton === 'This year'
                    }"
                    :style="getButtonStyle('This year')"
                    @click="setActiveButtonWrapper('This year')"
                  >
                    This year
                  </button>
                  <button
                    class="btn-selection btn btn-sm col-xxl-2 col-5 me-3"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Last year',
                      'btn-primary': activeButton === 'Last year'
                    }"
                    :style="getButtonStyle('Last year')"
                    @click="setActiveButtonWrapper('Last year')"
                  >
                    Last year
                  </button>
                  <!-- 自定義日期範圍 -->
                  <button
                    class="btn-selection btn btn-sm col-xxl-4 col-5"
                    :class="{
                      'btn-outline-primary': activeButton !== 'Custom date range',
                      'btn-primary': activeButton === 'Custom date range'
                    }"
                    :style="getButtonStyle('Custom date range')"
                    @click="toggleCustomDateRange"
                  >
                    {{ customDateLabel }}<i class="fa fa-angle-down"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row text-center">
              <!-- 顯示指標 -->
              <div v-for="(metric, key) in metrics" :key="key" class="col-md-4">
                <div class="metric-box">
                  <div>{{ metric.label }}</div>
                  <hr>
                  <div v-if="key == 'transaction_count'" class="value">{{ overviewInfo[key] }}</div>
                  <div v-else class="value">{{ formatCurrency(overviewInfo[key]) }}</div>
                  <div v-if="isPositive(overviewInfo[metric.diffKey])">
                    <img class="arrow-icon" src="@/assets/images/icon/up.png" :title="computedTooltip" data-bs-toggle="tooltip" />
                  </div>
                  <div v-else>
                    <img class="arrow-icon" src="@/assets/images/icon/down.png" :title="computedTooltip" data-bs-toggle="tooltip" />
                  </div>
                  <div :class="['metric-change', isPositive(overviewInfo[metric.diffKey]) ? 'text-success' : 'text-danger']"
                       :title="computedTooltip" data-bs-toggle="tooltip">
                    {{ overviewInfo[metric.diffKey] }}%
                  </div>
                </div>
              </div>
            </div>
            <!-- 日期選擇器 -->
            <div v-show="showDatePicker" class="datepicker-container">
              <Datepicker1 inline autoApply v-model="dateRange" :format="format" :enable-time-picker="false" range data-language="en"></Datepicker1>
              <button @click="applyCustomDateRange" class="btn btn-primary mt-2">Apply</button>
            </div>
          </div>
        </div>
      </div>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onUnmounted } from 'vue';
import { useOverviewStore } from '@/store/driver/overview';
import Datepicker1 from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { Tooltip } from 'bootstrap'; // 引入 Bootstrap 的 Tooltip

// 使用 Pinia store
const overviewStore = useOverviewStore();
const { overviewInfo, fetchOverviewInfo, setActiveButton } = overviewStore;

// 使用 computed 來從 store 中獲取 activeButton
const activeButton = computed(() => overviewStore.activeButton);

// 創建一個響應式數據來保存螢幕大小狀態
const isScreenSmall = ref(window.innerWidth < 1623);

// 定義一個函數來檢查螢幕寬度
const checkScreenWidth = () => {
  isScreenSmall.value = window.innerWidth < 1623;
};

const formatCurrency = (value) => {
    const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

// 按鈕選項
const dateOptions = [
  { label: 'Today', period: 'today' },
  { label: 'Yesterday', period: 'yesterday' },
  { label: 'This week', period: 'this_week' },
  { label: 'Last week', period: 'last_week' },
  { label: 'This month', period: 'this_month' },
  { label: 'Last month', period: 'last_month' },
  { label: 'This year', period: 'this_year' },
  { label: 'Last year', period: 'last_year' },
];

// 日期格式化函數
const format = (date) => {
  if (!(date instanceof Date)) {
    return ''; // 如果 date 不是 Date 物件，返回空字串
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2); // 顯示最後兩位數的年份

  return `${day}/${month}/${year}`;
};


// 用於追踪日期範圍選擇器
const dateRange = ref([]);
const showDatePicker = ref(false);

const customDateLabel = computed(() => {
  if (dateRange.value.length === 2) {
    const start = format(dateRange.value[0]);
    const end = format(dateRange.value[1]);
    return `${start} ~ ${end}`;
  }
  return 'Custom date range';
});

// 指標映射
const metrics = {
  face_value: { label: 'Face value', diffKey: 'face_value_diff_percent' },
  total_commission: { label: 'Total commission', diffKey: 'total_commission_diff_percent' },
  transaction_count: { label: 'Transactions', diffKey: 'transaction_count_diff_percent' },
};

// 計算提示文字
const computedTooltip = computed(() => {
  switch (activeButton.value) {
    case 'Today':
      return 'vs yesterday';
    case 'Yesterday':
      return 'vs the day prior';
    case 'This week':
      return 'vs last week';
    case 'Last week':
      return 'vs the week prior';
    case 'This Month':
      return 'vs last month';
    case 'Last Month':
      return 'vs the month prior';
    case 'This year':
      return 'vs last year';
    case 'Last year':
      return 'vs the year prior';
    case 'Custom date range':
      return 'vs the period prior';
    default:
      return '';
  }
});

// 判斷值是否為正數
const isPositive = (value) => value > 0;

// 設置選中的按鈕
const setActiveButtonWrapper = async (label) => {
  // 如果選擇的按鈕不是 Custom date range，則初始化 dateRange 和 customDateLabel
  if (label !== 'Custom date range') {
    dateRange.value = []; // 清空日期範圍
  }
  
  setActiveButton(label); // 使用 Pinia 的 actions
  fetchOverviewInfo(dateOptions.find(option => option.label === label).period);
  await nextTick(); // 等待 DOM 更新完成
  initializeTooltips(); // 重新初始化 Tooltips
};


// 切換日期範圍選擇器
const toggleCustomDateRange = async () => {
  setActiveButton('Custom date range'); // 使用 Pinia 的 actions
  showDatePicker.value = !showDatePicker.value;
  await nextTick(); // 等待 DOM 更新完成
  initializeTooltips(); // 重新初始化 Tooltips
};

// 應用自定義日期範圍
const applyCustomDateRange = async () => {
  if (dateRange.value.length === 2) {
    fetchOverviewInfo('custom', dateRange.value[0].toISOString().slice(0, 10), dateRange.value[1].toISOString().slice(0, 10));
  }
  showDatePicker.value = false;
  await nextTick(); // 等待 DOM 更新完成
  initializeTooltips(); // 重新初始化 Tooltips
};

// 根據按鈕標籤設置大小
const getButtonStyle = (label) => {
  const buttonSizes = {
    'Today': '95px',
    'Yesterday': '124px',
    'This week': '121px',
    'Last week': '124px',
    'This month': '131px',
    'Last month': '134px',
    'This year': '115px',
    'Last year': '118px',
    'Custom date range': '217px',
  };

  return {
    height: '40px',
    width: buttonSizes[label],
  };
};

// 初始化 Bootstrap Tooltips
const initializeTooltips = () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach((tooltipTriggerEl) => {
    new Tooltip(tooltipTriggerEl);
  });
};

onMounted(() => {
  fetchOverviewInfo('this_month');
  setActiveButtonWrapper('This month');
  initializeTooltips();
  window.addEventListener('resize', checkScreenWidth);
  // 檢查一次初始螢幕大小
  checkScreenWidth();
});

// 在組件卸載時移除 `resize` 事件監聽器
onUnmounted(() => {
  window.removeEventListener('resize', checkScreenWidth);
});
</script>

<style scoped>
.metric-box {
  margin: 20px 0;
  font-size: 18px;
}

.metric-box .value {
  font-size: 28px;
  font-weight: bold;
  margin: 30px;
}

.metric-change {
  display: flex;
  align-items: center;
  justify-content: center;
}

.key-metrics{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
  margin-bottom: 20px;
}

.text-success i {
  background-color: #00C962;
  color: white;
}

.text-danger i {
  background-color: red;
  color: white;
}

.card-header .btn {
  border-radius: 20px;
  padding: 5px 15px;
  margin-right: 10px;
  font-size: 16px;
}

.datepicker-container {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 5px;
}

.arrow-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
}

.selected-dates {
  border-radius: 20px;
  border: 2px solid #8476f4;
  color: #8476f4;
  padding: 5px;
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
  vertical-align: middle;
}

/* BTN_Selection */
.btn-selection {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 6px;
  height: 40px;
  border: 1px solid #5248DA;
  border-radius: 30px;
}
</style>
